<template lang="pug">
  .records
    .page-header
      h2 Executes

    h3 Leaderboards

    table(cellspacing="0", cellpadding="0")
      tr
        th Position
        th Score
        th Kills
        th Deaths
        th Player

      tr(v-for="record, index of records")
        td {{ (index + 1) + ($route.params.page - 1) * 30 }}
        td {{ record.score }}
        td {{ record.kills }}
        td {{ record.deaths }}
        td {{ record.name }}

    pagination(:page="$route.params.page", :pages="pages", :uri="`/executes/records/`")
</template>

<script>
import RecordsExecutesService from '@/services/RecordsExecutes';

import Pagination from '@/components/core/Pagination.vue';

export default {
  name: 'records-csgo-executes',
  components: {
    Pagination,
  },
  data() {
    return {
      records: [],
      pages: 1,
    };
  },
  methods: {
    async update() {
      if (!this.$route.params.page) {
        this.$route.params.page = 1;
      }

      const response = await RecordsExecutesService.getRecords(this.$route.params.page);
      if (response.error) {
        console.log(response.error);
        return;
      }

      this.records = response.data.records;
      this.pages = response.data.pages;
    },
  },
  created() {
    this.update();
  },
  watch: {
    $route() {
      this.update();
    },
  },
};
</script>

<style lang="scss" scoped>
table tr {
  td, th {
    width: 19%;

    &:last-child {
      width: 24%;
    }
  }
}
</style>
